import { render, staticRenderFns } from "./Humburguer.vue?vue&type=template&id=66b81110&"
import script from "./Humburguer.vue?vue&type=script&lang=ts&"
export * from "./Humburguer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports